<template>
    <object  @click="click()"  style="width:100%;max-height:300px" :data="getMediaItem()"
      type="image/png">
      <img id="image" style="width:100%" src="img/no-image.png" alt="" />
    </object>
</template>

<script>
  export default {
    props: {
      content: Object,
      click:Function
    },
    methods: {
      getMediaItem() {
        let self = this;
        return (
          process.env.VUE_APP_API + "SystemMedia?id=" + self.content.mediaId
        );
      },
    }
  };
</script>